import API from "../../../app/api";

export const getherobanner = async () => {
  try {
    const res = await API.get("/banners");
    if (res.data?.success) {
      return res.data?.data?.hero?.banners || [];
    }
    return [];
  } catch (error) {
    console.error("Hero Banner Error:", error);
    return [];
  }
};